module.exports = __webpack_public_path__ + "media/fonts/LearningCurve-928de684aeff00e9efccf3d2373bf2ed.woff2";